import { z } from "zod";
// ---------------------------------------------------------------------------
// Filtri comuni per tutte le query admin dashboard
// ---------------------------------------------------------------------------
export const AdminDashboardFiltersSchema = z.object({
    from: z.string().optional(), // ISO date string YYYY-MM-DD o datetime
    to: z.string().optional(),
    mailboxId: z.string().optional(),
    emailFrom: z.string().optional(), // ricerca parziale sul mittente
    days: z.coerce.number().int().min(1).max(365).optional(), // alternativa a from/to
});
// ---------------------------------------------------------------------------
// Riepilogo utilizzo
// ---------------------------------------------------------------------------
export const UsageSummarySchema = z.object({
    totalEvents: z.number().int(),
    totalRequests: z.number().int(), // n. chiamate AI (stage1 + stage2)
    stage1Requests: z.number().int(),
    stage2Requests: z.number().int(),
    totalTokens: z.number().int(),
    stage1Tokens: z.number().int(),
    stage2Tokens: z.number().int(),
    estimatedCostUsd: z.number(),
    errorCount: z.number().int(),
    periodFrom: z.string(),
    periodTo: z.string(),
});
// ---------------------------------------------------------------------------
// Serie temporale token per giorno
// ---------------------------------------------------------------------------
export const UsageTimeseriesPointSchema = z.object({
    date: z.string(), // YYYY-MM-DD
    totalTokens: z.number().int(),
    stage1Tokens: z.number().int(),
    stage2Tokens: z.number().int(),
    estimatedCostUsd: z.number(),
    eventCount: z.number().int(),
});
export const UsageTimeseriesSchema = z.object({
    points: z.array(UsageTimeseriesPointSchema),
});
// ---------------------------------------------------------------------------
// Top consumer per token
// ---------------------------------------------------------------------------
export const TopConsumerSchema = z.object({
    id: z.string(),
    emailFrom: z.string(),
    emailSubject: z.string(),
    emailReceivedAt: z.string(),
    mailboxLabel: z.string(),
    aiTotalTokens: z.number().int(),
    stage1Tokens: z.number().int().nullable(),
    stage2Tokens: z.number().int().nullable(),
    estimatedCostUsd: z.number(),
    status: z.string(),
});
export const TopConsumersResponseSchema = z.object({
    items: z.array(TopConsumerSchema),
});
// ---------------------------------------------------------------------------
// Log errori
// ---------------------------------------------------------------------------
export const ErrorLogItemSchema = z.object({
    id: z.string(),
    emailFrom: z.string(),
    emailSubject: z.string(),
    emailReceivedAt: z.string(),
    createdAt: z.string(),
    mailboxLabel: z.string(),
    errorMessage: z.string().nullable(),
    retryCount: z.number().int(),
    status: z.string(),
});
export const ErrorsResponseSchema = z.object({
    items: z.array(ErrorLogItemSchema),
    total: z.number().int(),
    page: z.number().int(),
    pageSize: z.number().int(),
});
// ---------------------------------------------------------------------------
// Stato limiti
// ---------------------------------------------------------------------------
export const RateLimitModelStatusSchema = z.object({
    model: z.string(),
    capturedAt: z.string().nullable(), // ISO datetime of last snapshot
    limitRequests: z.number().int().nullable(), // from x-ratelimit-limit-requests
    limitTokens: z.number().int().nullable(),
    remainingRequests: z.number().int().nullable(),
    remainingTokens: z.number().int().nullable(),
    resetRequestsMs: z.number().nullable(),
    resetTokensMs: z.number().nullable(),
});
export const LimitsStatusSchema = z.object({
    configuredLimitRpm: z.number().int(),
    configuredLimitTpm: z.number().int(),
    rollingRpm: z.number().nullable(), // requests (events) in last 60s × 2 (approx)
    rollingTpm: z.number().nullable(), // tokens in last 60s
    lastHourTokens: z.number().int(),
    last24hTokens: z.number().int(),
    modelSnapshots: z.array(RateLimitModelStatusSchema),
});
//# sourceMappingURL=adminDashboard.js.map